import { api } from "@/lib/api";
import { ApiResponse, ErrorResponse, Vendor } from "@/lib/types";
import { useMutation } from "@tanstack/react-query";

export interface CreateVendorPayload {
  name: string;
  contactPerson?: string;
  contactTitle?: string;
  email?: string;
  phone?: string;
  mobile?: string;
  website?: string;
  notes?: string;
  address?: string;
  city?: string;
  country?: string;
  vatNumber?: string;
  defaultCurrencyId?: string;
  paymentMethods?: Array<{
    name: string;
    description?: string;
    isDefault: boolean;
    iban?: string;
    swiftCode?: string;
    bankName?: string;
    bankAddress?: string;
    bankAccountNumber?: string;
    accountHolderName?: string;
    paymentReference?: string;
    paymentTerms?: string;
    currencyId: string;
  }>;
}

export const useCreateVendor = (props?: {
  onSuccess?: (data: ApiResponse<Vendor>) => void;
  onError?: (error: ErrorResponse) => void;
}) => {
  return useMutation<ApiResponse<Vendor>, ErrorResponse, CreateVendorPayload>({
    mutationFn: async (data: CreateVendorPayload) => {
      const response = await api.post<ApiResponse<Vendor>>("/vendors", data);
      return response.data;
    },
    ...props,
  });
};
